var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 128,
    viewBox: "0 0 152 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 152,
    height: 128,
    fill: "#ECEEEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.9715 83.7615C84.1226 83.7615 85.8664 82.0193 85.8664 79.8702C85.8664 77.7211 84.1226 75.9789 81.9715 75.9789C79.8204 75.9789 78.0765 77.7211 78.0765 79.8702C78.0765 82.0193 79.8204 83.7615 81.9715 83.7615Z",
    fill: "#C7CCD1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8352 53.9348V53.1304V49.7391V44C70.4172 44 66 48.3913 66 53.8261V53.9348V55.6304V74.1739C66 79.5869 70.3954 84 75.8352 84V68.1304V63.8913C81.3403 63.8913 85.801 59.4348 85.801 53.9348H75.8352Z",
    fill: "#C7CCD1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.51cbe72e.svg";
export { ForwardRef as ReactComponent };